import { Injectable } from '@angular/core';
import {
  ConnectionHttpService, ApiResourceLocation, ResponseResult,
  Store
} from '@softline/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SOFTLINE_API_BEWEAU_PICTURE } from '../goldschmiede.api';

@Injectable({ providedIn: 'root' })
export class PictureResourceService {
  constructor(private http: ConnectionHttpService, private store: Store) {}

  load(id: string): Observable<any> {
    const pathParams = { id };
    const queryParams = { kzqualitaet: 'I' }
    const resolvedLocation: ApiResourceLocation = {
      path: SOFTLINE_API_BEWEAU_PICTURE,
      pathParams,
      queryParams
    }

    return this.http.get<ResponseResult<any>>(resolvedLocation).pipe(
      map((o) => o?.result)
    )
  }
}
